import { Box } from '@mui/material';

export const HRM = () => {
  return <Box sx={{ flex: 1 }}></Box>;
};
